<template>
    <b-card>
        <b-card-body>
            <b-row>
                <b-col><h4 class="mb-4">Survey Results</h4></b-col>
                <b-col class="text-right">
<!--                    <b-button variant="success" size="sm" :href="apiUrl + 'api/session/' + session.id + '/export?auth=' + token" target="_blank" class="mr-3"><i class="fas fa-file-excel mr-2"></i>Export CSV/Excel</b-button>-->
                    <b-button target="_blank" variant="success" size="sm" :to="{name: 'print-sess-surveys', params:{id, sessId}}"><i class="fas fa-print mr-2"></i>Print</b-button>
                </b-col>
            </b-row>

            <h6>Question</h6>
            <b-select v-model="selectedQuestion" class="mb-5">
                <b-select-option v-for="q in session.survey" :value="q">{{q.title}}</b-select-option>
            </b-select>

            <div v-if="selectedQuestion && selectedQuestion.options">

                <div class="mb-3">{{optionSummary.total}} <strong>Responses</strong> from {{optionSummary.total+optionSummary.na}} <strong>Surveys</strong></div>
                <b-table-simple>
                    <b-thead head-variant="light">
                        <b-tr>
                            <b-th>Option</b-th>
                            <b-th>Responses</b-th>
                        </b-tr>
                    </b-thead>
                    <b-tbody>
                        <b-tr v-for="(r, t) in optionSummary.options">
                            <b-td>{{t}}</b-td>
                            <b-td>{{r}}</b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
            </div>
            <div v-if="selectedQuestion && !selectedQuestion.options">
                <div class="mb-3">{{questionResponses.total}} <strong>Responses</strong> from {{questionResponses.total+questionResponses.na}} <strong>Surveys</strong></div>

                <div v-for="(r, index) in questionResponses.responses" class="mt-3 pt-3" style="border-top: 1px solid #ddd;">
                    <strong>{{index+1}}</strong> {{r}}
                </div>
            </div>
        </b-card-body>
    </b-card>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import {apiUrl} from "../../../../constants/config";

    export default {
        name: "sess-surveys",
        props: ['sessId', 'id'],
        data: function () {
            return {
                session: {},
                selectedQuestion: null,
                apiUrl: apiUrl
            }
        },
        methods: {
            ...mapActions(['getSessionDetailsById']),
        },
        computed: {
            ...mapGetters(['token']),

            optionSummary: function () {
                if (this.session && this.session.enrollments) {
                    let results = {
                        total: 0,
                        na: 0,
                        options: {}
                    };

                    for (let i = 0; i < this.selectedQuestion.options.length; i++) {
                        const opt = this.selectedQuestion.options[i];
                        results.options[opt] = 0;
                    }
                    results.options['No Response'] = 0;

                    for (let i = 0; i < this.session.enrollments.length; i++) {
                        const s = this.session.enrollments[i].survey;

                        for (let j = 0; j < s.length; j++) {
                            if (s[j].field_id === this.selectedQuestion.id) {
                                if (s[j].value) {
                                    results.total++;
                                    results.options[s[j].value]++;
                                } else {
                                    results.na++
                                    results.options['No Response']++;
                                }
                                break;
                            }
                        }
                    }
                    return results;
                } else {
                    return {}
                }
            },
            questionResponses: function () {
                if (this.session && this.session.enrollments) {
                    let results = {
                        total: 0,
                        na: 0,
                        responses: []
                    };
                    for (let i = 0; i < this.session.enrollments.length; i++) {
                        const s = this.session.enrollments[i].survey;

                        for (let j = 0; j < s.length; j++) {
                            if (s[j].field_id === this.selectedQuestion.id) {
                                if (s[j].value) {
                                    results.total++;
                                    results.responses.push(s[j].value);
                                } else {
                                    results.na++;
                                }
                                break;
                            }
                        }

                    }
                    return results;
                } else {
                    return {}
                }
            }
        },
        mounted: function () {
            this.getSessionDetailsById(this.sessId).then(response => {
                this.session = response;
                this.selectedQuestion = this.session.survey[0];
            })
        }
    }
</script>

<style lang="scss" scoped>
    @import '~@/assets/scss/_variables.scss';


</style>
